import * as Sentry from "@sentry/react";

import { appStore } from "../store/store";

export const initSentry = () => {
  const { dsn, environment } = appStore.config.sentry ?? {};
  if (!dsn || !environment) return; // Environment should be set explicitly!

  Sentry.init({
    dsn,
    environment,
    sendDefaultPii: true,
  });
};
